module.exports = __webpack_public_path__ + "static/media/FélixHippolyte-Lucas.15141704.png";